import { isXandrVideoAdsCampaign } from '@bingads-webui-campaign-react/constants';

export const getDeviceOrder = ({
  permissions,
  navigationLevel,
  currentCampaign,
}) => {
  const order = ['Computer', 'Tablet', 'SmartPhone'];

  if (permissions.dynamic.XandrVideoCampaigns &&
      (navigationLevel !== 'campaign' ||
      (currentCampaign && isXandrVideoAdsCampaign(currentCampaign.CampaignSubType)))
  ) {
    order.push('ConnectedTV');
  }
  return order;
};
